"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Order',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  data: function data() {
    var _this = this;
    return {
      dealPhone: _index.dealPhone,
      deviceState: ['掉线', '正常', '维护', '异常'],
      drawer: true,
      agentInfo: {},
      form: {
        uid: this.$route.query.uid || ''
      },
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        start: 1,
        limit: 20,
        page_num: 1,
        check_order: '-1'
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      // 订单详情
      detailDialog: false,
      order: {}
    };
  },
  mounted: function mounted(options) {
    this.agentInfo = window.agentInfo;
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var params = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      if (params.begin) params.begin = this.parseTime(params.begin, '{y}-{m}-{d}');
      if (params.end) params.end = this.parseTime(params.end, '{y}-{m}-{d}');
      this.$get('agentapi/search/query_user_scan', params).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.page_num = res.page_num;
        if (params.start == 0) _this2.tableMaxH = window.innerHeight - _this2.$refs.list_table.$el.offsetTop - 85;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 获取订单详情
     */
    getOrderDetail: function getOrderDetail(order_id) {
      var _this3 = this;
      this.$get('wxapi/order_detail', {
        order_id: order_id
      }).then(function (res) {
        _this3.detailDialog = true;
        _this3.order = res;
      });
    }
  }
};